import * as React from "react";

function DownArrow(props) {
  return (
    <svg name={props?.name} stepIndex={props?.stepIndex} tabIndex={props?.tabIndex} onKeyDown={props?.onKeyDown} onClick={props?.click} className={props.className || "downArrow"} xmlns="http://www.w3.org/2000/svg" width="10.034" height="5.724" viewBox="0 0 10.034 5.724" style={{...props.styling, margin:"0px",...props?.style1}}><defs>
    {/* <style>.a{fill:none;stroke:#202020;stroke-miterlimit:10;}</style> */}
    </defs>
    <path className="a" fill="none" stroke={props.color||"#202020"} strokeMiterlimit="10" d="M0,9.327,4.663,4.664,0,0" transform="translate(9.681 0.354) rotate(90)"/>
    </svg>
  );
}

export default DownArrow;
